module.exports = __webpack_public_path__ + "img/mother.3415ed86.png";